import { http, HttpResponse } from "msw";
import { BASE_URL } from "../constants";
import { loadMock } from "../utils";

const userHandlers = [http.get(`${BASE_URL}/User/GetUserDetails`, async () => HttpResponse.json(await loadMock("User/userDetails")))];

export { userHandlers };
